import { SvgIcon } from '@mui/material';
import XpmLogoSvg from './assets/xpm-logo.svg';

export type TXpmLogoSize = 'small' | 'medium' | 'large';

const SIZE_MAPPING: { [key in TXpmLogoSize]: string } = {
  small: '30px',
  medium: '90px',
  large: '125px',
};

export function XpmLogo({ size = 'medium' }: { size?: TXpmLogoSize }) {
  return (
    <SvgIcon
      component={XpmLogoSvg}
      viewBox="0 0 69 69"
      sx={{
        width: SIZE_MAPPING[size],
        height: SIZE_MAPPING[size],
      }}
      aria-label="Xero Practice Manager"
    />
  );
}
